import {
  allThemePresets,
  type AppearanceOptions,
  type ThemePresetsKeys,
} from '@stripe-internal/embedded-theming';

/**
 * Applies a specified theming preset to the provided appearance options.
 * Note this only has an effect when the appearance options are not provided.
 * If the appearance options are provided, they take precedence over the theming preset.
 */
export const applyThemePreset = (
  options: AppearanceOptions | undefined,
  themingPreset: ThemePresetsKeys | undefined,
): AppearanceOptions | undefined => {
  // There's 3 cases:
  // 1. No theming preset is provided, we return the options as is
  if (!themingPreset) {
    return options;
  }

  // 2. Options are provided, in which case we ignore the theming preset and respect the options
  if (options) {
    return options;
  }

  // 3. We have a theming preset and no options, so we return the theme preset options
  const themingPresetAppearance =
    allThemePresets[themingPreset as Exclude<ThemePresetsKeys, 'upload'>];
  if (!themingPresetAppearance) {
    return options;
  }

  // We update the appearance with the theming preset
  return themingPresetAppearance.appearance;
};
